import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import ScrollSectionWitthChildren from 'components/scrollSection/scrollSectionWithChildren'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
export default function Urgence() {
   const { setCounter, counterDefault } = useCounterContext()
   const { setHeadband } = useContext(HeadbandContext)
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband("Astreintes Techniques")
      setAnchorButton([])
   }, [])
   return (
      <ScrollContainer>
         <ScrollSection zoneName="Astreintes Techniques" />
      </ScrollContainer>
   )
}
